import PropTypes from 'prop-types';
import React from 'react';
import { Question } from './Question';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';

export class NumberQuestion extends React.Component {
  onChange = () => {
    this.updateInputNumber();
  }

  updateInputNumber = () => {
    const questionnaireItemId = this.props.questionnaireItem.questionnaireItemId;
    this.props.updateAnswer(questionnaireItemId, this.input.value);

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  handleMinus = () => {
    let answer = parseInt(this.input.value, 10);
    if (isNaN(answer)) {
      answer = this.props.questionnaireItem.lowerBound;
    } else if (answer > this.props.questionnaireItem.lowerBound) {
      answer -= 1;
    }

    this.input.value = answer;
    this.updateInputNumber();
  }

  handlePlus = () => {
    let answer = parseInt(this.input.value, 10);
    if (isNaN(answer)) {
      answer = this.props.questionnaireItem.lowerBound;
    } else if (answer < this.props.questionnaireItem.upperBound) {
      answer += 1;
    }

    this.input.value = answer;
    this.updateInputNumber();
  }

  handleInputValue = (e) => {
    const inputValue = parseInt(e.key, 10);
    if (isNaN(inputValue)) {
      e.preventDefault();
    }
    this.updateInputNumber();
  }

  numberOnBlur = (event) => {
    if (event.target.value > this.props.questionnaireItem.upperBound) {
      this.input.value = this.props.questionnaireItem.upperBound;
      this.updateInputNumber();
    } else if (event.target.value < this.props.questionnaireItem.lowerBound) {
      this.input.value = this.props.questionnaireItem.lowerBound;
      this.updateInputNumber();
    }
  }

  render() {
    const { questionnaireItem } = this.props;
    const opts = {};
    opts.disabled = this.props.disabled;
    if (this.props.answerItem) {
      opts.value = this.props.answerItem.numberAnswer;
    }
    const invalidQuestionId = 'question_is_invalid_' + questionnaireItem.questionNumber;
    return (
      <div data-qa-item="number_question_type" className="question-area">
        <Question questionNumber={questionnaireItem.questionNumber}
          isValid={ questionnaireItem.isValid }
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <div className="row">
          <div className={questionnaireItem.isValid === false ? 'col is-invalid' : 'col'}>
            <div className="input-group number-spinner">
                  <button className="btn btn-outline-secondary" type="button" onClick={this.handleMinus}
                    data-qa-item="minus" disabled={this.props.disabled}
                  >
                  −
                  </button>
                <input type="text"
                  className="form-control border-dark border-top border-bottom"
                  ref={ (input) => { this.input = input; } }
                  data-qa-item="number_question_value"
                  onBlur={this.numberOnBlur}
                  onChange={this.onChange}
                  onKeyPress={this.handleInputValue}
                  {...opts}
                />
                  <button className="btn btn-outline-secondary" type="button" onClick={this.handlePlus}
                    disabled={this.props.disabled} data-qa-item="plus"
                  >
                  +
                  </button>
            </div> 
          </div>
          {
            questionnaireItem.isValid === false
              ? <span data-qa-item={ invalidQuestionId } className="invalid-feedback">
                  <FormattedMessage {...messages.error.required} />
                </span>
              : null
          }
        </div>
      </div>
    );
  }
}

NumberQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
